import React, { useState } from "react";
import { motion } from "framer-motion";
import { Reveal, stagger, fadeUp } from "./Reveal";
import { ArrowUpRight } from "lucide-react";
import { SERVICES, TONE_CLASS } from "../data/site";

const CATS = ["All", "Individual", "Couples", "Youth", "Family", "Mood"];

export const ServicesGrid = ({ onBook }) => {
  const [cat, setCat] = useState("All");
  const list = cat === "All" ? SERVICES : SERVICES.filter((s) => s.cat === cat);

  return (
    <section id="services" className="py-24 sm:py-32 bg-[#DFF0C4]/40 border-y border-[#C9DFAC]">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-12">
          <div>
            <Reveal><span className="overline">02 — What we work on together</span></Reveal>
            <Reveal delay={0.05}>
              <h2 className="section-title text-3xl sm:text-4xl lg:text-5xl mt-4 max-w-lg leading-tight text-[#20301A]">
                Care shaped around <em className="italic text-[#3A7D32]">your</em> mind
              </h2>
            </Reveal>
          </div>
          <Reveal delay={0.1}>
            <div className="flex flex-wrap gap-2">
              {CATS.map((c) => (
                <button key={c} data-testid={`services-filter-${c.toLowerCase()}`} onClick={() => setCat(c)}
                  className={`rounded-full px-4 py-2 text-xs font-medium transition-all duration-300 border ${
                    cat === c ? "bg-[#3A7D32] text-[#F2F8E8] border-[#3A7D32]" : "bg-transparent text-[#55703F] border-[#C9DFAC] hover:border-[#3A7D32]"}`}>
                  {c}
                </button>
              ))}
            </div>
          </Reveal>
        </div>

        <motion.div variants={stagger} initial="hidden" whileInView="visible" viewport={{ once: true, margin: "-60px" }}
          className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-5">
          {list.map((s, i) => (
            <motion.button key={s.key} variants={fadeUp} data-testid={`service-card-${s.key}`} onClick={onBook}
              className={`hover-lift text-left rounded-3xl border p-6 sm:p-7 group ${TONE_CLASS[s.tone]} ${i % 5 === 0 ? "lg:row-span-1" : ""}`}>
              <div className="flex items-start justify-between">
                <span className="font-mono text-[0.7rem] tracking-widest text-[#55703F]">{String(i + 1).padStart(2, "0")}</span>
                <ArrowUpRight size={18} className="text-[#3A7D32] opacity-0 group-hover:opacity-100 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-all" />
              </div>
              <h3 className="font-serif text-2xl mt-4 text-[#20301A]">{s.title}</h3>
              <p className="text-sm text-[#55703F] mt-2 leading-relaxed">{s.desc}</p>
              <span className="inline-block mt-4 text-[0.7rem] font-mono uppercase tracking-widest text-[#3A7D32]/70">{s.cat}</span>
            </motion.button>
          ))}
        </motion.div>
      </div>
    </section>
  );
};
